import { InfoStyled } from './styled';

import clsx from 'clsx';

interface InfoProps {
  className?: string;
}

const Info = ({ className }: InfoProps) => {
  return (
    <InfoStyled className={clsx('Info', className)}>
      <h1>
        환영합니다! <br /> <span>김대완</span>님
      </h1>
    </InfoStyled>
  );
};

export default Info;
